export default __webpack_public_path__ + "static/media/GuessJobs2_08.a09eca8d.png";